import { Skeleton } from '@/shared/components';
import { CarouselItem } from '@/shared/components/ui/carousel';

const SKELETON_CARDS_COUNT = 4;

const AccountCardContentSkeleton = () => {
  return Array.from({ length: SKELETON_CARDS_COUNT }, (_, index) => (
    <CarouselItem key={index} className="basis-[22rem] pl-0">
      <div className="flex flex-col gap-[0.4rem] w-full min-w-[18rem] max-w-[22rem] pb-[0.6rem] rounded-[1.6rem] bg-secondary-bg">
        <div className="flex flex-col gap-[1.2rem] p-[1.6rem] pl-[2rem] rounded-[1.6rem] bg-background ring-1 ring-inset ring-stroke shadow-card">
          <div className="flex h-[3.2rem] items-center justify-between gap-[1.2rem]">
            <Skeleton variant="avatar" className="size-[3.2rem]" />
            <Skeleton className="w-[4.8rem] h-[2rem]" />
          </div>

          <div className="flex flex-col gap-[0.2rem]">
            <div className="flex h-[2.2rem] items-center">
              <Skeleton variant="small" className="w-[8rem]" />
            </div>
            <div className="flex h-[2rem] items-center">
              <Skeleton variant="small" className="w-[10rem]" />
            </div>
          </div>
        </div>

        <div className="flex h-[3.2rem] items-center px-[1.6rem]">
          <Skeleton variant="small" className="w-[9rem]" />
        </div>
      </div>
    </CarouselItem>
  ));
};

export { AccountCardContentSkeleton };
